export var PythonEngineVersion;
(function (PythonEngineVersion) {
    PythonEngineVersion["V1"] = "1";
    PythonEngineVersion["V2"] = "2";
    PythonEngineVersion["V3"] = "3";
})(PythonEngineVersion || (PythonEngineVersion = {}));
export const LATEST_PYTHON_ENGINE_VERSION = PythonEngineVersion.V3;
export const DEFAULT_PYTHON_ENGINE_VERSION = PythonEngineVersion.V2;
//# sourceMappingURL=pythonEngineVersion.js.map